import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66137f1d")

_pushScopeId("data-v-66137f1d")
const _hoisted_1 = { class: "flex mt-2 h-full w-auto" }
const _hoisted_2 = { class: "absolute -top-6 -right-4 cursor-pointer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_card = _resolveComponent("card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_card, {
      class: "px-2",
      style: {"max-height":"max-content"}
    }, {
      default: _withId(() => [
        (_ctx.modelValue || _ctx.defaultImage)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: `relative ${_ctx.widthContentCard} flex my-3`,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args))),
              tabindex: _ctx.disabled ? '-1' : '0',
              role: "button",
              onKeydown: [
                _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)), ["enter"])),
                _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)), ["prevent"]), ["space"]))
              ]
            }, [
              (_ctx.isTypePdf || _ctx.typeFileDefaultIsPdf)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require(`@/app/ui/assets/images/default-pdf.jpeg`),
                    class: "h-24 w-24 object-cover rounded",
                    alt: "result-image"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _ctx.fileOriginal || _ctx.defaultImage,
                    class: `h-24 ${_ctx.widthImage} object-cover rounded`,
                    alt: "result-image"
                  }, null, 10, ["src"])),
              _createVNode("div", _hoisted_2, [
                (!_ctx.disabled)
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 0,
                      onClick: _ctx.setDefault,
                      name: "white-trash",
                      class: "w-5 text-red-lp-700",
                      tabindex: _ctx.disabled ? '-1' : '0',
                      role: "button",
                      onKeydown: [
                        _withKeys(_ctx.setDefault, ["enter"]),
                        _withKeys(_withModifiers(_ctx.setDefault, ["prevent"]), ["space"])
                      ]
                    }, null, 8, ["onClick", "tabindex", "onKeydown"]))
                  : _createCommentVNode("", true)
              ])
            ], 42, ["tabindex"]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              tabindex: _ctx.disabled ? '-1' : '0',
              role: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click())),
              onKeydown: [
                _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click()), ["enter"])),
                _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click()), ["prevent"]), ["space"]))
              ],
              onDragover: _cache[7] || (_cache[7] = e => _ctx.setDragAndDrop(e, true)),
              onDragleave: _cache[8] || (_cache[8] = e => _ctx.setDragAndDrop(e, false)),
              onDrop: _cache[9] || (_cache[9] = e => _ctx.onSubmitDrag(e)),
              class: 
          `flex justify-center ${_ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'} items-center text-12px border-2 border-dashed rounded-lg my-2 p-8 ${
            _ctx.isDragFile
              ? 'border-gray-lp-600 bg-gray-lp-100'
              : _ctx.isDataValidate
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          }`
        
            }, [
              _createVNode(_component_Icons, {
                class: !_ctx.isDataValidate ? 'text-gray-lp-600' : 'text-red-lp-1000',
                name: "grey-plus"
              }, null, 8, ["class"])
            ], 42, ["tabindex"])),
        _createVNode("input", {
          id: String(_ctx.$attrs.id),
          type: "file",
          ref: "file",
          onChange: _cache[10] || (_cache[10] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
          accept: _ctx.accept,
          class: "hidden",
          multiple: ""
        }, null, 40, ["id", "accept"]),
        _withDirectives(_createVNode("p", { class: "text-12px text-red-lp-1000" }, " Maks. " + _toDisplayString(_ctx.maxSize) + "MB ", 513), [
          [_vShow, _ctx.isDataValidate && _ctx.showErrorMessage]
        ]),
        _withDirectives(_createVNode("div", {
          class: `text-center pb-1 text-${_ctx.titleSize}px`
        }, null, 2), [
          [_directive_sanitize_html, 
          `${_ctx.title}<br />${
            _ctx.optional
              ? `
            <div
              class='text-center text-sm text-gray-lp-500'
              :class='text-${_ctx.titleSize}px'
            >
              (${_ctx.$t('optional')})
            </div>`
              : ''
          }`
        ]
        ])
      ]),
      _: 1
    })
  ]))
})